import React from "react";
import { Sidebar, SidebarBody, SidebarLink } from "../ui/sidebar";
import {
  IconHome,
  IconBooks,
  IconEdit,
  IconSettings,
  IconBlockquote,
  IconBell,
  IconUserShield,
  IconUsersGroup,
} from "@tabler/icons-react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

function DashboardLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const links = [
    { label: "Home", icon: <IconHome size={20} />, path: "/dashboard/home" },
    {
      label: "Manage Books",
      icon: <IconBooks size={20} />,
      path: "/dashboard/ebooks",
    },
    {
      label: "Daily Quotes",
      icon: <IconBlockquote size={20} />,
      path: "/dashboard/dailyquotes",
    },
    {
      label: "Admin Users",
      icon: <IconUserShield size={20} />,
      path: "/dashboard/adminusers",
    },
    {
      label: "Readers",
      icon: <IconUsersGroup size={20} />,
      path: "/dashboard/readers",
    },
    {
      label: "File Manager",
      icon: <IconBell size={20} />,
      path: "/dashboard/filemanager",
    },
    {
      label: "Settings",
      icon: <IconSettings size={20} />,
      path: "/dashboard/settings",
    },
  ];

  return (
    <div className="flex h-screen">
      <Sidebar>
        <SidebarBody>
          {links.map((link, index) => (
            <SidebarLink
              key={index}
              link={{ label: link.label, icon: link.icon }}
              onClick={() => navigate(link.path)}
              isSelected={location.pathname === link.path}
            />
          ))}
        </SidebarBody>
      </Sidebar>
      <main className="flex-1 p-8 bg-gray-50 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}

export default DashboardLayout;
